import { render, staticRenderFns } from "./PostDraft.vue?vue&type=template&id=d248edd6&scoped=true&"
import script from "./PostDraft.vue?vue&type=script&lang=js&"
export * from "./PostDraft.vue?vue&type=script&lang=js&"
import style0 from "./PostDraft.vue?vue&type=style&index=0&id=d248edd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d248edd6",
  null
  
)

export default component.exports